import React, {useEffect, useState} from 'react';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import ArrowCircleLeftOutlinedIcon from '@mui/icons-material/ArrowCircleLeftOutlined';
import { useNavigate } from 'react-router-dom';
import './index.css';
import favoriteIcon from '../icons/favorite.png';
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import pharmacyAvatar from '../icons/pharmacyAvatar.jpg';
import Button from '@mui/material/Button';
import { Link,useLocation } from 'react-router-dom';
import axios from "axios";
import FavoriteIcon from "@mui/icons-material/Favorite";
import { getToken } from "../../../auth/authenticate";

const url = `${process.env.REACT_APP_BACKEND_URL}user/pharmacy/`;
const pharmacy = {
  businessName: String,
  district: String,
  serviceArea: String,
  description: String,
};

const PharmacyInfo = () => {

  const navigate = useNavigate();
  const location = useLocation();
  const [pharmacyInfo, setPharmacyInfo] = useState(pharmacy);
  const path = location.pathname.split("/")[3];
  
  useEffect(() => {
    fetchData();
  }, [path]);

  const fetchData = async () => {
    let config = {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    };
    const result = await axios.get(url+path, config);
    setPharmacyInfo(result?.data?.data);
  };

  const addToFavourites = async (id) => {
    let config = {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    };
    const result = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}favourite/patient/add-pharmacy/${id}`,
      config
    );
    if (result) {
      alert("Added to favourites successfully");
      fetchData();
    }
  };

  const removeFromFavourites = async (id) => {
    let config = {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    };
    const result = await axios.delete(
      `${process.env.REACT_APP_BACKEND_URL}favourite/patient/remove-pharmacy/${id}`,
      config
    );
    if (result) {
      alert("Removed from favourites successfully");
      await fetchData();
    }
  };
  return (
    <div className="pharmacyInfoMain">
      <>
        <div className="pharmacyInfoMainHeading">
          <div onClick={() => navigate(-1)}>
            <ArrowCircleLeftOutlinedIcon
              className="headingIcon"
              fontSize="large"
            />
          </div>
          <h3>Pharmacy info</h3>
        </div>
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            "& > :not(style)": {
              ml: 1,
              mr: 2,
              pl: 2,
              pb: 3,
              pt: 2,
              width: "100%",
              height: "auto",
            },
          }}
        >
          <Paper elevation={1} pl={5}>
            <div className="pharmacyInfoAvatar">
              {pharmacyInfo?.isFavourite ? (
                <div
                style={{marginRight: "10px"}}
                  onClick={() => {
                    removeFromFavourites(pharmacyInfo.pharmacyId);
                  }}
                >
                  <FavoriteIcon
                    style={{ color: "red", width: "15px", height: "15px" }}
                    className="favoriteIcon"
                  />
                </div>
              ) : (
                <div
                style={{marginRight: "10px"}}
                  onClick={() => {
                    addToFavourites(pharmacyInfo.pharmacyId);
                  }}
                >
                  <img
                    src={favoriteIcon}
                    alt="Favorite Icon"
                    width={15}
                    height={15}
                    className="favoriteIcon"
                  />
                </div>
              )}
              <Stack direction="row" spacing={1}>
                <Avatar
                  alt="Patient Avatar"
                  src={pharmacyInfo?.User?.profileImagePath || pharmacyAvatar}
                  variant="rounded"
                />
                <div className="pharmacyInfoName">
                  <h5>{pharmacyInfo?.businessName}</h5>
                  <p>{pharmacyInfo?.district}</p>
                </div>
              </Stack>
              <div className="pharmacyInfoOrder">
                <div className="pharmacyInfoType">
                  <p>Type</p>
                  <h5 className="capitalize">{pharmacyInfo?.serviceArea}</h5>
                </div>
                <div className="pharmacyInfoType">
                  <p>Orders</p>
                  <h5>0</h5>
                </div>
              </div>
            </div>
            <div className="aboutPharmacy">
              <h5>About this Pharmacy</h5>
              <p>{pharmacyInfo?.description}</p>
              <Link to="add-more-info" className="paymentHistoryLink">
                <Button variant="contained">Order</Button>
              </Link>
            </div>
          </Paper>
        </Box>
      </>
    </div>
  );
}
export default PharmacyInfo;
